import React from 'react';
import { Dialog, DialogBody, DialogTitle } from './dialog';
import { Button } from './button';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  description: string;
  isCritical?: boolean;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  isCritical = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogBody>
        <DialogTitle>{title}</DialogTitle>
        <p className="mt-2 text-zinc-600">{description}</p>
        <div className="flex justify-end gap-2 mt-6">
          <Button color="light" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button color={isCritical ? 'red' : 'light'} onClick={handleConfirm} disabled={isLoading}>
              {confirmText}
          </Button>
        </div>
      </DialogBody>
    </Dialog>
  );
}; 